import { Toolpad } from '../Toolpad';
import { useTranslation } from '../../../i18n';
import { useUIStore, useMovieStore } from '../../../stores';

export function ClipFolders() {
  const { t } = useTranslation();
  const { toolpads, toggleToolpad } = useUIStore();
  const { clipFolders, addClipFolder, deleteClipFolder } = useMovieStore();
  const isOpen = toolpads.clipFolders.isOpen;

  const handleAddFolder = () => {
    const newFolder = {
      id: `folder-${Date.now()}`,
      name: t('toolpads.clipFolders.defaultName', { count: clipFolders.length + 1 }),
      items: [],
    };
    addClipFolder(newFolder);
  };

  return (
    <Toolpad
      title={t('toolpads.clipFolders.title')}
      isOpen={isOpen}
      onToggle={() => toggleToolpad('clipFolders')}
    >
      <div className="clip-folders">
        {clipFolders.length === 0 ? (
          <div className="clip-folders-empty">{t('toolpads.clipFolders.empty')}</div>
        ) : (
          clipFolders.map((folder) => (
            <div key={folder.id} className="clip-folder-item">
              <span className="folder-icon">📁</span>
              <span className="folder-name">{folder.name}</span>
              <span className="folder-count">({folder.items.length})</span>
              <button
                className="folder-delete"
                onClick={() => deleteClipFolder(folder.id)}
                title={t('toolpads.clipFolders.deleteTooltip')}
              >
                ×
              </button>
            </div>
          ))
        )}
        <div className="clip-folders-actions">
          <button className="btn" onClick={handleAddFolder}>
            {t('toolpads.clipFolders.add')}
          </button>
        </div>
      </div>
    </Toolpad>
  );
}
